import React from "react";
import { Stack, Button, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setConfig } from "../../Redux/Action";
import { setModal } from "../../../../Common/App";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { ConfirmGenerateModal } from "../Modals/ConfirmGenerateModal";

export const TableActions = () => {
    const dispatch = useDispatch();
    const filters = useSelector((store) => store.rosterJobs?.config?.filters);

    const handleViewChange = (event, newView) => {
        if (newView !== null) {
            dispatch(setConfig({
                filters: {
                    ...filters,
                    view: newView,
                },
                pagination: {
                    page: 0,
                    pageSize: 10,
                }
            }));
        }
    };

    const handleManualRun = () => {
        dispatch(setModal({
            component: <ConfirmGenerateModal />,
            open: true,
            size: 'sm'
        }));
    };

    return (
        <Stack direction={"row"} spacing={2} alignItems="center">
            {/* View Toggle */}
            <ToggleButtonGroup
                value={filters?.view || 'all'}
                exclusive
                onChange={handleViewChange}
                size="small"
            >
                <ToggleButton value="all">
                    All Jobs
                </ToggleButton>
                <ToggleButton value="failed">
                    Failed Jobs
                </ToggleButton>
            </ToggleButtonGroup>

            {/* Manual Run Button */}
            <Button 
                variant="contained" 
                size="small"
                startIcon={<PlayArrowIcon />}
                onClick={handleManualRun}
            >
                Generate Now
            </Button>
        </Stack>
    );
};

